import Route from '@core/components/Route';
import Grid2 from '@shared/components/Grid2';
import { H3 } from '@shared/components/Heading';
import List from '@shared/components/List';
import ListItem from '@shared/components/ListItem';
import Paragraph from '@shared/components/Paragraph';
import Video from '@shared/components/Video';
import { FC, memo } from 'react';

import { ALEXANDER_SOLOVEV_CV } from '../../assets/data/alexander-solovev-cv';
import { ALEXANDER_SOLOVEV_PROSA } from '../../assets/data/alexander-solovev-prosa';
import { H2Gold } from '../../components/ColoredHeading';
import { SectionDark3 } from '../../components/ColoredSection';
import GenericLayout from '../../components/GenericLayout';
import PageImageAS from '../../components/PageImageAS';

const AlexanderSolovev: FC = () => (
  <GenericLayout title='Alexander Solovev'>
    <PageImageAS />

    <SectionDark3>
      <H2Gold>Alexander Solovev</H2Gold>

      <Video src={'310949077'} sx={{ display: { md: 'none' } }}></Video>

      <Grid2 spacing={{ md: '2rem', xs: '1.5rem' }}>
        <Grid2.Item>
          <H3>Lebenslauf</H3>
          <List bullets itemProps={{ margin: '0' }}>
            {ALEXANDER_SOLOVEV_CV.map(text => (
              <ListItem key={text}>{text}</ListItem>
            ))}
          </List>
        </Grid2.Item>
        <Grid2.Item>
          <H3>Kampfkunst</H3>
          <List bullets itemProps={{ margin: '0' }}>
            {ALEXANDER_SOLOVEV_PROSA.map((item, index) => (
              <ListItem key={index}>{item}</ListItem>
            ))}
          </List>
        </Grid2.Item>
      </Grid2>

      <Video src={'310949077'} sx={{ display: { md: 'block', xs: 'none' } }} />

      <Paragraph margin={{ top: '3rem' }}>
        Weitere Informationen zu Alexander Solovev finden sich auf seiner Website:
        <br />
        <Route href='https://solovevstyle.ab.ru/'>solovevstyle.ab.ru</Route>
      </Paragraph>
    </SectionDark3>
  </GenericLayout>
);

export default memo(AlexanderSolovev);
